import {
  compactFormat,
  dimension,
  dimensionSelector,
  granularity,
  legendPosition,
  palette,
  showItems,
} from "@/settings/charts/settingsDictionary";
import { FAMILY } from "@/settings/widgetFamilies";
import { Config } from "@/types/charts";

export default <Config>{
  family: [FAMILY.OVERTIME, FAMILY.COMPARISON],
  title: "Grouped Column Chart",
  defaultHeight: 6,
  controls: [{ ...dimension, metricName: "xAxis" }, granularity],
  settings: {
    palette,
    showItems: { ...showItems, gridPosition: [3, 0] },
    legendPosition: { ...legendPosition, gridPosition: [4, 0] },
    compactFormat: { ...compactFormat, gridPosition: [5, 0] },

    xAxis: {
      default: "channel",
      type: "select",
      label: "Horizontal Axis Metric",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },

    yAxisPrimary: {
      default: "spend",
      type: "select",
      label: "Primary Vertical Axis Metric",
      dictionary: "displayMetrics",
      gridPosition: [1, 0],
      tooltipOrder: 1,
    },

    yAxisSecondary: {
      default: "purchase_value",
      type: "select",
      label: "Secondary Vertical Axis Metric",
      dictionary: "displayMetrics",
      gridPosition: [2, 0],
      tooltipOrder: 2,
    },

    xAxisTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [0, 1],
      forAxis: "xAxis",
    },

    yAxisTitlePrimary: {
      default: "",
      type: "text",
      label: "Primary Vertical Axis Title",
      gridPosition: [1, 1],
      forAxis: "yAxisPrimary",
    },

    yAxisSecondaryTitle: {
      default: "",
      type: "text",
      label: "Secondary Vertical Axis Title",
      gridPosition: [2, 1],
      forAxis: "yAxisSecondary",
    },
  },
  planSettings: {
    palette,
    showItems: { ...showItems, gridPosition: [3, 0] },
    legendPosition: { ...legendPosition, gridPosition: [4, 0] },
    compactFormat: { ...compactFormat, gridPosition: [5, 0] },

    xAxis: {
      default: "channel",
      type: "select",
      label: "Horizontal Axis Metric",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },

    yAxisPrimary: {
      default: "channel_budget",
      type: "select",
      label: "Primary Vertical Axis Metric",
      dictionary: "displayMetrics",
      gridPosition: [1, 0],
      tooltipOrder: 1,
    },

    yAxisSecondary: {
      default: "purchase_value",
      type: "select",
      label: "Secondary Vertical Axis Metric",
      dictionary: "displayMetrics",
      gridPosition: [2, 0],
      tooltipOrder: 2,
    },

    xAxisTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [0, 1],
      forAxis: "xAxis",
    },

    yAxisTitlePrimary: {
      default: "",
      type: "text",
      label: "Primary Vertical Axis Title",
      gridPosition: [1, 1],
      forAxis: "yAxisPrimary",
    },

    yAxisSecondaryTitle: {
      default: "",
      type: "text",
      label: "Secondary Vertical Axis Title",
      gridPosition: [2, 1],
      forAxis: "yAxisSecondary",
    },
  },
  familySettings: {
    [FAMILY.OVERTIME]: {
      legendPosition: { ...legendPosition, gridPosition: [3, 0] },
      compactFormat: { ...compactFormat, gridPosition: [4, 0] },
      showItems: undefined,

      xAxis: {
        default: "month",
        type: "select",
        label: "Horizontal Axis Metric",
        dictionary: "timeMetrics",
        apiParameter: "dimension",
        gridPosition: [0, 0],
        tooltipOrder: 0,
      },
    },
    [FAMILY.COMPARISON]: {
      dimensionSelector: { ...dimensionSelector, gridPosition: [6, 0] },
    },
  },
};
